module.exports = __webpack_public_path__ + "img/I2C_Fig07.129c1c27.png";